import KeyValueFormFields from './KeyValueFormFields';

export default KeyValueFormFields;
